import React, { createContext, useContext, useMemo, useState } from "react";

export const translations = {
  fr: {
    "welcome.eyebrow": "INTERFACE D'ACCUEIL INTELLIGENTE",
    "welcome.title": "Bienvenue chez ST DIGITAL",
    "welcome.copy": "Isaac Ahmed vous accompagne pour votre visite, votre rendez-vous et vos questions d'orientation.",
    "welcome.cta": "COMMENCER",

    "home.eyebrow": "ACCUEIL CENTRAL",
    "home.title1": "Bienvenue chez",
    "home.title2": "ST DIGITAL",
    "home.subtitle": "Votre partenaire digital, partout et à chaque instant.",
    "home.badge1": "SÉCURISÉ",
    "home.badge2": "RAPIDE",
    "home.badge3": "INTELLIGENT",
    "home.parcours": "CHOISISSEZ VOTRE PARCOURS",
    "home.rdv.title": "RENDEZ-VOUS",
    "home.rdv.desc": "Prendre ou gérer un rendez-vous",
    "home.ia.title": "PARLER À ISAAC",
    "home.ia.desc": "Poser une question à l'assistant IA",
    "home.trust.secure": "Connexion sécurisée",
    "home.trust.available": "Disponible 24/7",
    "home.trust.tech": "Technologie de pointe",
    "home.profile": "Back-office",
    "home.backoffice.indispo": "L'espace du personnel ne s'ouvre pas depuis cet accès. Utilisez la borne de l'accueil ou demandez le lien à l'équipe technique.",
    "home.backoffice.fermer": "Fermer",
    "home.menu": "Menu",
    "home.logo": "Retour à l'accueil",
    "home.available": "Isaac est disponible",
    "home.orbAria": "Ouvrir la conversation avec Isaac",
    "home.site": "Libreville",

    "rdv.actions.title": "Rendez-vous",
    "rdv.actions.subtitle": "Gestion de votre visite chez ST DIGITAL",
    "rdv.action.create.title": "Prendre rendez-vous",
    "rdv.action.create.text": "Remplir les informations nécessaires pour une nouvelle demande.",
    "rdv.action.identify.title": "J'ai un rendez-vous",
    "rdv.action.identify.text": "S'identifier par code ou par QR code.",
    "rdv.action.departure.title": "Signaler mon départ",
    "rdv.action.departure.text": "Présentez le même code en repartant, pour clore votre visite.",
    "rdv.action.myappointments.title": "Consulter mes rendez-vous",
    "rdv.action.myappointments.text": "Voir l'état de vos demandes : confirmées, en attente, refusées.",

    "rdv.header.actions.title": "Rendez-vous",
    "rdv.header.actions.subtitle": "Gestion de votre visite chez ST DIGITAL",
    "rdv.header.create.title": "Prendre un rendez-vous",
    "rdv.header.create.subtitle": "Remplissez le formulaire pour soumettre votre demande",
    "rdv.header.identify-choice.title": "J'ai un rendez-vous",
    "rdv.header.identify-choice.subtitle": "Identifiez-vous pour retrouver votre invitation",
    "rdv.header.manual-code.title": "Saisir mon code",
    "rdv.header.manual-code.subtitle": "Entrez le code présent sur votre invitation",
    "rdv.header.scanner.title": "Scanner mon invitation",
    "rdv.header.scanner.subtitle": "Présentez le QR code devant la caméra",
    "rdv.header.summary.title": "Ma visite",
    "rdv.header.summary.subtitle": "Vérifiez les informations avant de confirmer",
    "rdv.header.notify.title": "Confirmation",
    "rdv.header.notify.subtitle": "Votre présence a été traitée",
    "rdv.header.my-appointments.title": "Consulter mes rendez-vous",
    "rdv.header.my-appointments.subtitle": "Retrouvez l'état de vos demandes",
    "rdv.header.request-done.title": "Demande envoyée",
    "rdv.header.request-done.subtitle": "Votre demande a bien été transmise",
    "rdv.header.departure-choice.title": "Signaler mon départ",
    "rdv.header.departure-choice.subtitle": "Identifiez-vous pour enregistrer votre sortie",
    "rdv.header.departure-code.title": "Saisir mon code",
    "rdv.header.departure-code.subtitle": "Le même code que celui présenté à votre arrivée",
    "rdv.header.departure-scanner.title": "Scanner mon invitation",
    "rdv.header.departure-scanner.subtitle": "Présentez le QR code devant la caméra",
    "rdv.header.departure-done.title": "Départ enregistré",
    "rdv.header.departure-done.subtitle": "Votre visite est close",
    "rdv.header.request-failed.title": "Envoi impossible",
    "rdv.header.request-failed.subtitle": "Un problème est survenu",

    "rdv.back": "Retour",
    "rdv.goHome": "ST-ACCUEIL",

    "rdv.identify.code.title": "S'identifier par code",
    "rdv.identify.code.text": "Saisir le code présent sur votre invitation.",
    "rdv.identify.scan.title": "Scanner le QR code",
    "rdv.identify.scan.text": "Utiliser la caméra pour lire votre invitation.",

    "rdv.manualcode.title": "Invitation",
    "rdv.manualcode.intro": "Saisissez le code présent sur votre invitation.",
    "rdv.manualcode.placeholder": "Code invitation",
    "rdv.manualcode.submit": "Valider",

    "rdv.scanner.title": "Invitation",
    "rdv.scanner.intro": "Présentez le QR code de votre invitation devant la caméra.",

    "rdv.create.title": "Demande de rendez-vous",
    "rdv.create.intro": "Votre demande est centralisée directement dans notre système d'accueil : elle est transmise à l'équipe compétente, qui sera notifiée pour la traiter.",
    "rdv.create.submit": "Envoyer la demande",

    "rdv.field.firstName": "Prénom",
    "rdv.field.lastName": "Nom",
    "rdv.field.email": "Email",
    "rdv.field.phone": "Téléphone",
    "rdv.field.company": "Société",
    "rdv.field.jobTitle": "Fonction / statut (optionnel)",
    "rdv.field.host": "Hôte souhaité",
    "rdv.field.dataCenter": "Centre de données",
    "rdv.field.accessType": "Type d'accès",
    "rdv.field.date": "Date de début",
    "rdv.field.endDate": "Date de fin prévisible",
    "rdv.field.time": "Heure de début",
    "rdv.field.purpose": "Motif de la demande",
    "rdv.field.referrerName": "Nom du commercial référent (optionnel)",
    "rdv.field.referrerPhone": "Téléphone du commercial référent (optionnel)",
    "rdv.field.remarks": "Remarques additionnelles (optionnel)",
    "rdv.field.idDocument": "Pièce d'identité (CNI ou Passeport)",
    "rdv.field.photo": "Photo du visiteur",
    "rdv.field.terms": "J'accepte les conditions d'accès et m'engage à respecter le règlement intérieur",

    "rdv.datacenter.libreville": "Libreville LBV01 - Libreville, Gabon",
    "rdv.datacenter.douala": "Douala DLA01 - Douala, Cameroun",
    "rdv.datacenter.abidjan": "Abidjan ABJ01 - Grand Bassam, Cote d'ivoire",

    "rdv.accesstype.visite": "Visite",
    "rdv.accesstype.interne": "Demande interne staff",
    "rdv.accesstype.intervention": "Intervention",
    "rdv.accesstype.prestataire": "Demande prestataire",
    "rdv.accesstype.client": "Demande de client data center",
    "rdv.accesstype.stagiaire": "Stagiaire",
    "rdv.accesstype.livraison": "Livraison",

    "rdv.host.site_manager": "Site Manager (par défaut, toujours disponible)",
    "rdv.host.commercial": "Hôte commercial (offres, tarifs)",
    "rdv.host.technique": "Hôte technique (Direction Technique)",
    "rdv.host.securite": "Hôte sécurité",
    "rdv.host.rh": "Hôte RH (stagiaires, recrutement)",
    "rdv.host.marketing": "Hôte marketing (communication, événementiel)",
    "rdv.host.admin_financier": "Hôte administratif et financier (facturation, comptabilité)",

    "rdv.requestdone.text": "Votre demande a bien été transmise. L'équipe la traitera et préviendra la personne concernée.",
    "rdv.requestdone.action": "Retour aux rendez-vous",
    "rdv.requestfailed.text": "Votre demande n'a pas pu être transmise. Merci de vous présenter directement à l'accueil ou de réessayer.",
    "rdv.requestfailed.action": "Réessayer",

    "rdv.summary.title": "Informations visite",
    "rdv.summary.visitor": "Visiteur",
    "rdv.summary.company": "Entreprise",
    "rdv.summary.host": "Hôte",
    "rdv.summary.date": "Date",
    "rdv.summary.purpose": "Objet",
    "rdv.summary.confirm": "Confirmer ma présence",
    "rdv.summary.codeSpent": "Ce code a déjà servi pour une visite terminée. Il n'est plus valable. Merci de vous adresser à l'accueil.",
    "rdv.summary.alreadyIn": "Votre arrivée est déjà enregistrée depuis {heure}. Vous pouvez enregistrer votre sortie.",

    "rdv.departure.code.title": "Saisir mon code",
    "rdv.departure.code.intro": "Entrez le code que vous avez présenté à votre arrivée. Votre heure de sortie sera enregistrée.",
    "rdv.departure.code.submit": "Enregistrer ma sortie",
    "rdv.departure.scan.title": "Scanner mon invitation",
    "rdv.departure.scan.intro": "Présentez le même QR code qu'à votre arrivée pour enregistrer votre sortie.",
    "rdv.departure.done.title": "Départ enregistré",
    "rdv.departure.done.text": "Votre sortie a bien été enregistrée. Bonne fin de journée.",
    "rdv.departure.done.entry": "Arrivée",
    "rdv.departure.done.exit": "Départ",
    "rdv.departure.done.duration": "Durée de la visite",

    "rdv.notify.action": "Retour à l'accueil",
    "rdv.notify.fallback": "La notification n'a pas pu être transmise. Merci de vous présenter directement à l'accueil.",

    "rdv.myapp.title": "Consulter mes rendez-vous",
    "rdv.myapp.emailIntro": "Entrez l'email utilisé lors de votre demande. Un code de vérification vous sera envoyé pour confirmer votre identité.",
    "rdv.myapp.emailPlaceholder": "Votre email",
    "rdv.myapp.sendCode": "Recevoir un code",
    "rdv.myapp.sending": "Envoi...",
    "rdv.myapp.otpTitle": "Vérification",
    "rdv.myapp.otpIntroBefore": "Un code à 6 chiffres a été envoyé à",
    "rdv.myapp.otpIntroAfter": "Il expire dans 5 minutes.",
    "rdv.myapp.otpPlaceholder": "Code reçu par email",
    "rdv.myapp.verify": "Valider",
    "rdv.myapp.verifying": "Vérification...",
    "rdv.myapp.changeEmail": "Changer d'email",
    "rdv.myapp.listTitle": "Mes rendez-vous",
    "rdv.myapp.empty": "Aucun rendez-vous trouvé pour cet email.",
    "rdv.myapp.hostPrefix": "hôte :",
    "rdv.myapp.cancel": "Annuler",
    "rdv.myapp.status.confirme": "Confirmé",
    "rdv.myapp.status.enattente": "En cours de confirmation",
    "rdv.myapp.status.refuse": "Refusé",
    "rdv.myapp.status.annule": "Annulé",

    "chat.back": "Retour",
    "chat.title": "Isaac Ahmed",
    "chat.subtitle": "Assistant d'accueil",
    "chat.you": "Vous",
    "chat.isaac": "Isaac",
    "voix.ouvrir": "Parler à Isaac",
    "voix.parler": "PARLER",
    "voix.titre": "Conversation parlée avec Isaac",
    "voix.fermer": "Fermer la conversation parlée",
    "voix.salutation": "Bonjour, je suis Isaac, l'assistant d'accueil de ST Digital. Comment puis-je vous aider ?",
    "voix.etat.arret": "",
    "voix.etat.ecoute": "ISAAC VOUS ÉCOUTE",
    /* Sous le libellé d'écoute : c'est le seul moment où la consigne peut
       encore changer quelque chose à ce qui sera entendu. */
    "voix.ecoute.consigne": "Parlez haut et articulez bien",
    /* Pendant qu'il parle, la seule chose utile est de ne pas parler
       par-dessus : une voix superposée à la sienne dégrade la
       reconnaissance du tour suivant. */
    "voix.parle.consigne": "Vous pourrez parler dès qu'il a terminé",
    "voix.etat.parle": "ISAAC RÉPOND",
    "voix.etat.reflechit": "ISAAC CHERCHE LA RÉPONSE",
    "voix.etat.pret": "Appuyez pour parler",
    "voix.terminer": "Terminer",
    "voix.appuyez": "APPUYEZ POUR PARLER",
    "voix.attentecourt": "Cela peut prendre une minute.",
    /* « Une minute » datait du temps ou une question coûtait cent secondes.
       À la place, une consigne qui sert vraiment : mieux on articule, mieux
       la reconnaissance entend. Le compteur reste — c'est le seul signe que
       la demande est vivante. */
    "voix.attente": "Un instant, je vous prie. Je prépare votre réponse. {s} s",
    "voix.bouton.parler": "Parler",
    "voix.bouton.fini": "J'ai fini de parler",
    "voix.aide": "Appuyez pour parler, appuyez de nouveau quand vous avez fini. Isaac vous répond à voix haute.",
    "voix.etat.pause": "MICRO COUPÉ",
    /* « MICRO COUPÉ » dit l'état, pas la suite. Sans cette phrase, la mise en
       pause passait pour une conversation qui s'était terminée seule. */
    "voix.pause.explication": "La conversation est gardée. Appuyez sur « Reprendre la parole » quand vous voulez continuer.",
    /* Ce qu'Isaac ajoute à voix haute quand il vient de transmettre une demande
       commerciale. Il annonce une action RÉELLE et déjà partie — pas une
       visite, pas un rappel promis à la place de quelqu'un d'autre. */
    /* « Écrivez-la sur l'écran », et non « dites-la moi » : une adresse
       épelée à voix haute revient fausse bien trop souvent, et une adresse
       fausse ne vaut pas mieux qu'aucune. */
    "voix.commercial.surplace": "Votre demande est bien enregistrée : je la transmets au service commercial, et un commercial la prendra en charge. Écrivez votre adresse électronique sur l'écran pour qu'il puisse vous répondre, ou passez à l'accueil.",
    /* À L'ORAL, ON TOUCHE. Faire dépendre tout le scénario d'un mot d'une
       syllabe transcrit de travers, c'est ce qui s'est produit le 02/10. */
    "voix.commercial.demande": "Cette demande dépend de votre situation : seul un commercial peut la chiffrer. Si vous souhaitez que je la transmette au service commercial, touchez Oui sur l'écran ; sinon, touchez Non.",
    "voix.accord.oui": "Oui, transmettez",
    "voix.accord.non": "Non, merci",
    "voix.commercial.refus": "Entendu, je ne transmets rien. Je reste à votre disposition.",
    "voix.commercial.suite": "Très bien. Écrivez sur l'écran l'adresse à laquelle vous joindre, puis validez — je transmets tout au service commercial.",
    "voix.commercial.adistance": "Votre demande est bien enregistrée : je la transmets au service commercial, et un commercial la prendra en charge. Écrivez votre adresse électronique sur l'écran pour qu'il puisse vous répondre.",
    "voix.contact.invite": "Votre adresse électronique, pour que le commercial vous réponde",
    "voix.contact.exemple": "nom@entreprise.com",
    "voix.contact.envoyer": "Envoyer",
    "voix.contact.plustard": "Plus tard",
    "voix.contact.invalide": "Cette adresse ne semble pas complète. Vous pouvez aussi saisir un numéro de téléphone.",
    "voix.clavier.titre": "Clavier à l'écran",
    "voix.clavier.effacer": "Effacer le dernier caractère",
    "voix.clavier.fermer": "Masquer le clavier",
    "voix.clavier.ouvrir": "Afficher le clavier",
    "voix.commercial.contact": "C'est fait. Votre demande est partie au service commercial avec cette adresse, et vous recevrez un message de confirmation.",
    "voix.commercial.echec": "Je n'ai pas pu prévenir le service commercial. Vous pouvez les joindre au 66 17 66 41.",
    "voix.corriger": "Ce n'est pas ce que j'ai dit",
    "voix.couper": "Couper le micro",
    "voix.reprendre": "Reprendre la parole",
    "chat.voice.start": "Parler à Isaac",
    "chat.voice.dicter": "Dicter votre message au lieu de le taper",
    "chat.voice.stop": "J'ai fini de parler",
    "chat.voice.listening": "Je vous écoute, appuyez de nouveau quand vous avez fini",
    "chat.voice.working": "Je transcris ce que vous avez dit...",
    "chat.voice.micRefuse": "Le micro n'est pas accessible. Vérifiez qu'il est branché et autorisé pour cette page.",
    "chat.voice.on": "Voix activée",
    "chat.voice.off": "Voix coupée",
    "chat.voice.muteOn": "Lire les réponses à voix haute",
    "chat.voice.muteOff": "Ne plus lire les réponses à voix haute",
    "chat.placeholder": "Posez votre question à Isaac...",
    "chat.send": "Envoyer",
    "chat.ariaLabel": "Message pour Isaac",
    "chat.greeting": "Bonjour, je suis Isaac Ahmed, assistant d'accueil ST DIGITAL. Comment puis-je vous orienter ?",
    "chat.fallbackError": "Je ne peux pas répondre pour le moment. Merci de vous présenter à l'accueil pour votre question.",
    "chat.status.quick": "Isaac prépare votre réponse…",
    "chat.status.retrieving": "Isaac prépare votre réponse…",
    "chat.status.generating": "Isaac rédige sa réponse…",
    "chat.step.understood": "Je comprends votre question",
    "chat.step.searching": "Je cherche la réponse",
    "chat.step.writing": "Je rédige la réponse",
    "chat.suggest.hours": "Quels sont vos horaires ?",
    "chat.suggest.datacenter": "Où se trouve le Datacenter ?",
    "chat.suggest.visit": "Je viens pour un rendez-vous",
    "chat.suggest.about": "Que fait ST DIGITAL ?",
    "chat.escalation.title": "Ça prend plus de temps que prévu.",
    "chat.escalation.wait": "Continuer à patienter",
    "chat.escalation.escalate": "Être mis en relation avec un membre de l'équipe",
    "chat.relais.reserve": "Un tarif, un contrat ou une disponibilité réelle dépendent de votre situation : je ne peux pas les annoncer à la place de l'équipe. Voulez-vous être mis en relation avec une personne habilitée ?",
    "chat.relais.ignorance": "Cette question demande une réponse qu'une personne de l'équipe est mieux placée que moi pour vous donner. Voulez-vous que je la transmette ?",
    "chat.relais.oui": "Oui, prévenir quelqu'un",
    "chat.relais.non": "Non merci, je continue",
    "chat.escalated.surplace": "C'est transmis. Un membre de l'équipe a été prévenu et vient vous rejoindre à l'accueil.",
    "chat.escalated.adistance": "C'est transmis à l'équipe. Pour qu'elle puisse vous répondre, laissez-moi votre nom et un moyen de vous joindre — téléphone ou adresse électronique.",
    "chat.escalateFailed": "Je n'ai pas pu prévenir l'équipe pour le moment. Vous pouvez nous joindre au +241 66 17 66 41 ou par courriel à info@st.digital.",
    /* Une borne est partagée : le fil s'efface. Mais on prévient avant, et on
       le dit après — un écran qui se vide en silence se lit comme une panne. */
    "chat.session.terminer": "Terminer la session",
    "chat.session.bientot": "Cette conversation va s'effacer dans un instant, faute d'activité.",
    "chat.session.rester": "Je suis toujours là",
    "chat.session.finie": "Conversation effacée. La borne est prête pour la personne suivante.",
    /* Un prix dimensionne sur un besoin ne se trouve pas dans une base : il se
       calcule avec le client. On ne propose donc pas la mise en relation, on la
       fait, et on le dit au passe — le courriel est deja parti quand la phrase
       s'affiche. */
    "chat.commercial.surplace": "Cette demande dépend de votre situation : seul un commercial peut la chiffrer. Votre demande est bien enregistrée et transmise au service commercial, qui la prendra en charge. Laissez-moi votre adresse électronique pour qu'un commercial vous réponde, ou présentez-vous à l'accueil.",
    /* QUAND ISAAC VIENT DE LE DIRE LUI-MÊME. Sa réponse annonçait déjà la
       transmission : la répéter mot pour mot donne deux messages qui se
       marchent dessus. Il ne reste qu'une chose à ajouter — où laisser son
       adresse. */
    /* ON NE TRANSMET RIEN SANS UN OUI. « C'est fait » suppose un accord ;
       Isaac le demande donc, et d'une façon à laquelle on répond debout,
       sans réfléchir. */
    "chat.commercial.demande": "Cette demande dépend de votre situation : seul un commercial peut la chiffrer. Souhaitez-vous que je transmette votre demande au service commercial ? Répondez par oui ou non.",
    "chat.commercial.refus": "Entendu, je ne transmets rien. Je reste à votre disposition si vous changez d'avis ou si vous avez une autre question.",
    /* ÉTAPE 3 DU SCÉNARIO : on demande, on ne conclut pas. « C'est fait »
       appartient à l'étape 5, une fois l'adresse reçue. Annoncer la fin au
       milieu donnait deux conclusions pour une seule demande. */
    "chat.commercial.suite": "Très bien. Écrivez l'adresse à laquelle vous joindre dans le champ ci-dessous, puis envoyez — je transmets tout au service commercial.",
    "chat.commercial.adistance": "Cette demande dépend de votre situation : seul un commercial peut la chiffrer. Votre demande est bien enregistrée et transmise au service commercial, qui la prendra en charge. Laissez-moi votre adresse électronique pour qu'un commercial vous réponde.",
    /* L'ADRESSE EST MAL ÉCRITE. Dans ce contexte, « je n'ai pas saisi votre
       demande » est à côté : Isaac n'attendait pas une demande. */
    "chat.commercial.invalide": "Je n'ai pas reconnu d'adresse électronique là-dedans. Écrivez-la en entier, avec l'arobase et le nom de domaine — par exemple prenom@entreprise.com.",
    "chat.commercial.sansAdresse": "Entendu, je n'insiste pas. Votre demande est déjà partie au service commercial ; si vous changez d'avis, écrivez-moi votre adresse à tout moment.",
    /* ÉTAPE 5 : la seule conclusion du scénario. */
    "chat.commercial.contact": "C'est fait. Votre demande est partie au service commercial avec cette adresse, et vous recevrez un message de confirmation.",
    /* « Plus tard » ne doit pas etre definitif : la demande est deja partie,
       il ne manque qu'un moyen d'y repondre. */
    "chat.commercial.rouvrir": "Laisser mon adresse au service commercial",
    /* Quand Isaac attend une adresse, le champ de la conversation le dit —
       il n'y a pas de second champ. */
    "chat.commercial.placeholder": "Écrivez ici l'adresse à laquelle vous joindre...",

    "camera.unavailable": "La caméra est inaccessible depuis ce navigateur. Merci de vous présenter à l'accueil.",
    "photo.activate": "Activer la caméra",
    "photo.capture": "Prendre la photo",
    "photo.alt": "Photo du visiteur capturée",
    "photo.done": "Photo capturée",
    "photo.retake": "Reprendre la photo",
  },
  en: {
    "welcome.eyebrow": "SMART RECEPTION INTERFACE",
    "welcome.title": "Welcome to ST DIGITAL",
    "welcome.copy": "Isaac Ahmed assists you with your visit, your appointment, and any general questions.",
    "welcome.cta": "GET STARTED",

    "home.eyebrow": "MAIN MENU",
    "home.title1": "Welcome to",
    "home.title2": "ST DIGITAL",
    "home.subtitle": "Your digital partner, everywhere, every moment.",
    "home.badge1": "SECURE",
    "home.badge2": "FAST",
    "home.badge3": "SMART",
    "home.parcours": "CHOOSE YOUR PATH",
    "home.rdv.title": "APPOINTMENT",
    "home.rdv.desc": "Book or manage an appointment",
    "home.ia.title": "TALK TO ISAAC",
    "home.ia.desc": "Ask the AI assistant a question",
    "home.trust.secure": "Secure connection",
    "home.trust.available": "Available 24/7",
    "home.trust.tech": "Cutting-edge technology",
    "home.profile": "Back office",
    "home.backoffice.indispo": "The staff area does not open from this access. Use the front desk kiosk, or ask the technical team for the link.",
    "home.backoffice.fermer": "Close",
    "home.menu": "Menu",
    "home.logo": "Back to home",
    "home.available": "Isaac is available",
    "home.orbAria": "Open the conversation with Isaac",
    "home.site": "Libreville",

    "rdv.actions.title": "Appointments",
    "rdv.actions.subtitle": "Manage your visit at ST DIGITAL",
    "rdv.action.create.title": "Book an appointment",
    "rdv.action.create.text": "Fill in the details for a new request.",
    "rdv.action.identify.title": "I have an appointment",
    "rdv.action.identify.text": "Identify yourself with a code or QR code.",
    "rdv.action.departure.title": "Sign out",
    "rdv.action.departure.text": "Show the same code on your way out to close your visit.",
    "rdv.action.myappointments.title": "View my appointments",
    "rdv.action.myappointments.text": "Check your requests' status: confirmed, pending, declined.",

    "rdv.header.actions.title": "Appointments",
    "rdv.header.actions.subtitle": "Manage your visit at ST DIGITAL",
    "rdv.header.create.title": "Book an appointment",
    "rdv.header.create.subtitle": "Fill in the form to submit your request",
    "rdv.header.identify-choice.title": "I have an appointment",
    "rdv.header.identify-choice.subtitle": "Identify yourself to retrieve your invitation",
    "rdv.header.manual-code.title": "Enter my code",
    "rdv.header.manual-code.subtitle": "Enter the code shown on your invitation",
    "rdv.header.scanner.title": "Scan my invitation",
    "rdv.header.scanner.subtitle": "Present the QR code to the camera",
    "rdv.header.summary.title": "My visit",
    "rdv.header.summary.subtitle": "Check the details before confirming",
    "rdv.header.notify.title": "Confirmation",
    "rdv.header.notify.subtitle": "Your presence has been processed",
    "rdv.header.my-appointments.title": "View my appointments",
    "rdv.header.my-appointments.subtitle": "Check the status of your requests",
    "rdv.header.request-done.title": "Request sent",
    "rdv.header.request-done.subtitle": "Your request has been submitted",
    "rdv.header.departure-choice.title": "Sign out",
    "rdv.header.departure-choice.subtitle": "Identify yourself to record your departure",
    "rdv.header.departure-code.title": "Enter my code",
    "rdv.header.departure-code.subtitle": "The same code you showed on arrival",
    "rdv.header.departure-scanner.title": "Scan my invitation",
    "rdv.header.departure-scanner.subtitle": "Hold the QR code in front of the camera",
    "rdv.header.departure-done.title": "Departure recorded",
    "rdv.header.departure-done.subtitle": "Your visit is now closed",
    "rdv.header.request-failed.title": "Sending failed",
    "rdv.header.request-failed.subtitle": "Something went wrong",

    "rdv.back": "Back",
    "rdv.goHome": "ST-HOME",

    "rdv.identify.code.title": "Identify with a code",
    "rdv.identify.code.text": "Enter the code shown on your invitation.",
    "rdv.identify.scan.title": "Scan the QR code",
    "rdv.identify.scan.text": "Use the camera to read your invitation.",

    "rdv.manualcode.title": "Invitation",
    "rdv.manualcode.intro": "Enter the code shown on your invitation.",
    "rdv.manualcode.placeholder": "Invitation code",
    "rdv.manualcode.submit": "Submit",

    "rdv.scanner.title": "Invitation",
    "rdv.scanner.intro": "Present your invitation's QR code to the camera.",

    "rdv.create.title": "Appointment request",
    "rdv.create.intro": "Your request is centralized directly in our reception system: it is forwarded to the relevant team, who will be notified to process it.",
    "rdv.create.submit": "Send the request",

    "rdv.field.firstName": "First name",
    "rdv.field.lastName": "Last name",
    "rdv.field.email": "Email",
    "rdv.field.phone": "Phone",
    "rdv.field.company": "Company",
    "rdv.field.jobTitle": "Job title / status (optional)",
    "rdv.field.host": "Requested host",
    "rdv.field.dataCenter": "Data center",
    "rdv.field.accessType": "Access type",
    "rdv.field.date": "Start date",
    "rdv.field.endDate": "Expected end date",
    "rdv.field.time": "Start time",
    "rdv.field.purpose": "Purpose of the request",
    "rdv.field.referrerName": "Referring sales rep's name (optional)",
    "rdv.field.referrerPhone": "Referring sales rep's phone (optional)",
    "rdv.field.remarks": "Additional remarks (optional)",
    "rdv.field.idDocument": "ID document (national ID or passport)",
    "rdv.field.photo": "Visitor photo",
    "rdv.field.terms": "I accept the access conditions and agree to comply with the internal rules",

    "rdv.datacenter.libreville": "Libreville LBV01 - Libreville, Gabon",
    "rdv.datacenter.douala": "Douala DLA01 - Douala, Cameroon",
    "rdv.datacenter.abidjan": "Abidjan ABJ01 - Grand Bassam, Ivory Coast",

    "rdv.accesstype.visite": "Visit",
    "rdv.accesstype.interne": "Internal staff request",
    "rdv.accesstype.intervention": "Intervention",
    "rdv.accesstype.prestataire": "Contractor request",
    "rdv.accesstype.client": "Data center client request",
    "rdv.accesstype.stagiaire": "Intern",
    "rdv.accesstype.livraison": "Delivery",

    "rdv.host.site_manager": "Site Manager (default, always available)",
    "rdv.host.commercial": "Sales host (offers, pricing)",
    "rdv.host.technique": "Technical host (Technical Direction)",
    "rdv.host.securite": "Security host",
    "rdv.host.rh": "HR host (interns, recruitment)",
    "rdv.host.marketing": "Marketing host (communication, events)",
    "rdv.host.admin_financier": "Administrative and financial host (billing, accounting)",

    "rdv.requestdone.text": "Your request has been received. The team will process it and notify the person concerned.",
    "rdv.requestdone.action": "Back to appointments",
    "rdv.requestfailed.text": "Your request could not be sent. Please come directly to the reception desk or try again.",
    "rdv.requestfailed.action": "Try again",

    "rdv.summary.title": "Visit details",
    "rdv.summary.visitor": "Visitor",
    "rdv.summary.company": "Company",
    "rdv.summary.host": "Host",
    "rdv.summary.date": "Date",
    "rdv.summary.purpose": "Purpose",
    "rdv.summary.confirm": "Confirm my presence",
    "rdv.summary.codeSpent": "This code has already been used for a completed visit. It is no longer valid. Please see the front desk.",
    "rdv.summary.alreadyIn": "Your arrival was already recorded at {heure}. You can record your departure.",

    "rdv.departure.code.title": "Enter my code",
    "rdv.departure.code.intro": "Enter the code you showed on arrival. Your departure time will be recorded.",
    "rdv.departure.code.submit": "Record my departure",
    "rdv.departure.scan.title": "Scan my invitation",
    "rdv.departure.scan.intro": "Show the same QR code as on arrival to record your departure.",
    "rdv.departure.done.title": "Departure recorded",
    "rdv.departure.done.text": "Your departure has been recorded. Have a good day.",
    "rdv.departure.done.entry": "Arrival",
    "rdv.departure.done.exit": "Departure",
    "rdv.departure.done.duration": "Visit duration",

    "rdv.notify.action": "Back to home",
    "rdv.notify.fallback": "The notification could not be sent. Please come directly to the reception desk.",

    "rdv.myapp.title": "View my appointments",
    "rdv.myapp.emailIntro": "Enter the email used for your request. A verification code will be sent to confirm your identity.",
    "rdv.myapp.emailPlaceholder": "Your email",
    "rdv.myapp.sendCode": "Receive a code",
    "rdv.myapp.sending": "Sending...",
    "rdv.myapp.otpTitle": "Verification",
    "rdv.myapp.otpIntroBefore": "A 6-digit code was sent to",
    "rdv.myapp.otpIntroAfter": "It expires in 5 minutes.",
    "rdv.myapp.otpPlaceholder": "Code received by email",
    "rdv.myapp.verify": "Verify",
    "rdv.myapp.verifying": "Verifying...",
    "rdv.myapp.changeEmail": "Change email",
    "rdv.myapp.listTitle": "My appointments",
    "rdv.myapp.empty": "No appointments found for this email.",
    "rdv.myapp.hostPrefix": "host:",
    "rdv.myapp.cancel": "Cancel",
    "rdv.myapp.status.confirme": "Confirmed",
    "rdv.myapp.status.enattente": "Awaiting confirmation",
    "rdv.myapp.status.refuse": "Declined",
    "rdv.myapp.status.annule": "Cancelled",

    "chat.back": "Back",
    "chat.title": "Isaac Ahmed",
    "chat.subtitle": "Reception assistant",
    "chat.you": "You",
    "chat.isaac": "Isaac",
    "voix.ouvrir": "Speak to Isaac",
    "voix.parler": "SPEAK",
    "voix.titre": "Spoken conversation with Isaac",
    "voix.fermer": "Close the spoken conversation",
    "voix.salutation": "Hello, I am Isaac, the ST Digital front desk assistant. How may I help you?",
    "voix.etat.arret": "",
    "voix.etat.ecoute": "ISAAC IS LISTENING",
    "voix.ecoute.consigne": "Speak up and articulate clearly",
    "voix.parle.consigne": "You can speak as soon as he has finished",
    "voix.etat.parle": "ISAAC IS ANSWERING",
    "voix.etat.reflechit": "ISAAC IS SEARCHING",
    "voix.etat.pret": "Press to speak",
    "voix.terminer": "End",
    "voix.appuyez": "PRESS TO SPEAK",
    "voix.attentecourt": "This can take a minute.",
    "voix.attente": "One moment, please. I am preparing your answer. {s} s",
    "voix.bouton.parler": "Speak",
    "voix.bouton.fini": "I have finished speaking",
    "voix.aide": "Press to speak, press again when you have finished. Isaac answers aloud.",
    "voix.etat.pause": "MICROPHONE OFF",
    "voix.pause.explication": "The conversation is kept. Press “Start speaking again” whenever you want to continue.",
    "voix.commercial.surplace": "Your request is recorded: I am passing it to the sales team, and a sales representative will take it from here. Type your email address on the screen so they can reply to you, or go to the front desk.",
    "voix.commercial.demande": "This depends on your own setup: only a sales representative can price it. If you would like me to pass it on to the sales team, tap Yes on the screen; otherwise tap No.",
    "voix.accord.oui": "Yes, pass it on",
    "voix.accord.non": "No, thank you",
    "voix.commercial.refus": "Understood, I am not passing anything on. I remain at your disposal.",
    "voix.commercial.suite": "Very well. Type the address where we can reach you on the screen and confirm — I will pass everything on to the sales team.",
    "voix.commercial.adistance": "Your request is recorded: I am passing it to the sales team, and a sales representative will take it from here. Type your email address on the screen so they can reply to you.",
    "voix.contact.invite": "Your email address, so the sales team can reply",
    "voix.contact.exemple": "name@company.com",
    "voix.contact.envoyer": "Send",
    "voix.contact.plustard": "Later",
    "voix.contact.invalide": "That address looks incomplete. You can also enter a phone number.",
    "voix.clavier.titre": "On-screen keyboard",
    "voix.clavier.effacer": "Delete the last character",
    "voix.clavier.fermer": "Hide the keyboard",
    "voix.clavier.ouvrir": "Show the keyboard",
    "voix.commercial.contact": "Done. Your request has gone to the sales team with that address, and you will receive a confirmation message.",
    "voix.commercial.echec": "I could not reach the sales team. You can call them on 66 17 66 41.",
    "voix.corriger": "That is not what I said",
    "voix.couper": "Turn the microphone off",
    "voix.reprendre": "Start speaking again",
    "chat.voice.start": "Speak to Isaac",
    "chat.voice.dicter": "Dictate your message instead of typing it",
    "chat.voice.stop": "I have finished speaking",
    "chat.voice.listening": "I am listening, press again when you have finished",
    "chat.voice.working": "Transcribing what you said...",
    "chat.voice.micRefuse": "The microphone is not available. Check that it is connected and allowed for this page.",
    "chat.voice.on": "Voice on",
    "chat.voice.off": "Voice off",
    "chat.voice.muteOn": "Read answers aloud",
    "chat.voice.muteOff": "Stop reading answers aloud",
    "chat.placeholder": "Ask Isaac a question...",
    "chat.send": "Send",
    "chat.ariaLabel": "Message to Isaac",
    "chat.greeting": "Hello, I'm Isaac Ahmed, ST DIGITAL's reception assistant. How can I help direct you?",
    "chat.fallbackError": "I can't answer right now. Please come to the reception desk with your question.",
    "chat.status.quick": "Isaac is preparing your answer…",
    "chat.status.retrieving": "Isaac is preparing your answer…",
    "chat.status.generating": "Isaac is writing the answer…",
    "chat.step.understood": "I understand your question",
    "chat.step.searching": "I am looking for the answer",
    "chat.step.writing": "I am writing the answer",
    "chat.suggest.hours": "What are your opening hours?",
    "chat.suggest.datacenter": "Where is the Datacenter?",
    "chat.suggest.visit": "I am here for an appointment",
    "chat.suggest.about": "What does ST DIGITAL do?",
    "chat.escalation.title": "This is taking longer than expected.",
    "chat.escalation.wait": "Keep waiting",
    "chat.escalation.escalate": "Get help from a team member",
    "chat.relais.reserve": "Pricing, contracts and real availability depend on your situation: I cannot state them on the team's behalf. Would you like to be put in touch with someone authorised?",
    "chat.relais.ignorance": "This question calls for an answer that someone on the team is better placed to give than I am. Would you like me to pass it on?",
    "chat.relais.oui": "Yes, notify someone",
    "chat.relais.non": "No thanks, I'll carry on",
    "chat.escalated.surplace": "Passed on. A team member has been notified and is on their way to the reception desk.",
    "chat.escalated.adistance": "Passed on to the team. So that they can get back to you, please leave me your name and a way to reach you — phone or email.",
    "chat.escalateFailed": "I could not reach the team right now. You can contact us on +241 66 17 66 41 or by email at info@st.digital.",
    "chat.session.terminer": "End the session",
    "chat.session.bientot": "This conversation will be cleared shortly, after a period without activity.",
    "chat.session.rester": "I am still here",
    "chat.session.finie": "Conversation cleared. The kiosk is ready for the next person.",
    "chat.commercial.surplace": "This depends on your own setup: only a sales representative can price it. Your request is recorded and passed to the sales team, who will take it from here. Leave me your email address so a sales representative can reply, or go to the front desk.",
    "chat.commercial.demande": "This depends on your own setup: only a sales representative can price it. Would you like me to pass your request on to the sales team? Please answer yes or no.",
    "chat.commercial.refus": "Understood, I am not passing anything on. I remain at your disposal if you change your mind or have another question.",
    "chat.commercial.suite": "Very well. Type the address where we can reach you in the field below and send it — I will pass everything on to the sales team.",
    "chat.commercial.adistance": "This depends on your own setup: only a sales representative can price it. Your request is recorded and passed to the sales team, who will take it from here. Leave me your email address so a sales representative can reply.",
    "chat.commercial.invalide": "I did not recognise an email address in that. Please write it in full, with the at sign and the domain name — for example firstname@company.com.",
    "chat.commercial.sansAdresse": "Understood, I will not insist. Your request has already gone to the sales team; if you change your mind, type your address at any time.",
    "chat.commercial.contact": "Done. Your request has gone to the sales team with that address, and you will receive a confirmation message.",
    "chat.commercial.rouvrir": "Leave my address for the sales team",
    "chat.commercial.placeholder": "Type here the address where we can reach you...",

    "camera.unavailable": "The camera is unavailable in this browser. Please come to the reception desk.",
    "photo.activate": "Turn on the camera",
    "photo.capture": "Take the photo",
    "photo.alt": "Captured visitor photo",
    "photo.done": "Photo captured",
    "photo.retake": "Retake the photo",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => window.localStorage.getItem("isaac_language") || "fr");

  function changeLanguage(lang) {
    setLanguage(lang);
    window.localStorage.setItem("isaac_language", lang);
  }

  const value = useMemo(() => ({
    language,
    setLanguage: changeLanguage,
    t: (key) => translations[language]?.[key] ?? translations.fr[key] ?? key,
  }), [language]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
  return ctx;
}
